import Error from "next/error";

import NotFound from "pages/404";
import ServerError from "pages/500";

interface ErrorProps {
    statusCode: number | boolean;
};

const ErrorComponent = ({ statusCode }: ErrorProps) => {
    let stCode: number;

    if (typeof statusCode === "number") {
        stCode = statusCode;
    }

    if (statusCode === 404) {
        return <NotFound />
    }

    if (statusCode === 500) {
        return <ServerError />
    }

    return (
        <Error statusCode={stCode!} />
    );
};

export default ErrorComponent;
